import { useCallbackRef } from '@chakra-ui/react';
import { useEffect } from 'react';

export const useOnUnmount = (callback) => {
  const cb = useCallbackRef(() => {
    callback?.();
  });

  useEffect(() => {
    return () => {
      cb();
    };
  }, [cb]);
};
